import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { jobMail } from 'store/saveSearch/saveSearch';
import { trackConversion } from 'store/experiments/experiments';

import JobMailTinyForm from 'JobMailTinyForm/JobMailTinyForm';

const mapStateToProps = ({ search, results, saveSearch, user }) => ({
  query: search.query,
  location: results.location,
  status: saveSearch.status,
  errorMessage: saveSearch.errorMessage,
  authenticated: user.authenticated
});

const mapDispatchToProps = dispatch => ({
  createJobMailSubscription: ({ query, location, emailAddress }) => {
    dispatch(jobMail({ query, location, emailAddress }));
    dispatch(trackConversion('e8762e94-ce6e-4de9-83f1-3be87e2d323a'));
  }
});

@connect(mapStateToProps, mapDispatchToProps)
export default class JobMailTiny extends Component {
  static propTypes = {
    authenticated: PropTypes.bool.isRequired,
    query: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    createJobMailSubscription: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.handleJobMailSubmission = this.handleJobMailSubmission.bind(this);
  }

  handleJobMailSubmission(emailAddress) {
    const { createJobMailSubscription, query, location } = this.props;

    return e => {
      e.preventDefault();
      createJobMailSubscription({ query, location, emailAddress });
    };
  }

  render() {
    const { status, errorMessage, authenticated } = this.props;

    return (!authenticated &&
      <JobMailTinyForm
        status={status}
        message={errorMessage}
        submissionHandler={this.handleJobMailSubmission}
        prompt="Receive new jobs for this search by email"
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SavePanelTiny/SavePanelTiny.js
 **/